const Component = () => import('./AisleSelection');

export { Component };
